import { useState } from 'react';
import { getAlignment } from '../../../engine/taxonomyOracle';
import LoadingSpinner from '../components/common/LoadingSpinner';
import ErrorBanner from '../components/common/ErrorBanner';

export function TaxonomyOraclePanel() {
  const [code, setCode] = useState('C20.14');
  const [res, setRes] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const query = async () => {
    setLoading(true);
    setError(null);
    setRes(null);
    try {
      const result = await getAlignment(code);
      setRes(result);
    } catch (e) {
      const error = e instanceof Error ? e : new Error('Failed to query taxonomy oracle');
      setError(error);
      console.error('Taxonomy oracle query failed:', e);
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="space-y-3">
      <div className="font-orbitron text-evat-gold">EU Taxonomy Oracle</div>
      <div className="text-xs text-yellow-400">DEMO SIGNATURE ONLY</div>
      
      <ErrorBanner error={error} onRetry={query} showRetry={!!error} />
      
      {loading && <LoadingSpinner size="sm" text="Querying..." />}
      
      <div className="flex gap-2 text-sm">
        <input
          value={code}
          onChange={(e)=>setCode(e.target.value)}
          disabled={loading}
          className="bg-black border border-evat-neon text-evat-neon rounded px-2 py-1 disabled:opacity-50"
          aria-label="NACE code"
        />
        <button
          onClick={query}
          disabled={loading}
          className="px-3 py-1 rounded border border-evat-neon text-evat-neon hover:shadow-neon disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {loading ? 'Querying...' : 'Query'}
        </button>
      </div>
      {res && (
        <div className="border border-neutral-700 rounded p-3 text-sm">
          <div>Alignment: <span className="text-evat-gold">{res.alignmentPct}%</span> • Version: {res.version}</div>
          <div className="text-xs break-all text-neutral-400 mt-2">Signature: {res.signature}</div>
        </div>
      )}
    </div>
  );
}

export default TaxonomyOraclePanel;














